import { render, staticRenderFns } from "./CountryFlagDisplay.vue?vue&type=template&id=303f7632&scoped=true"
import script from "./CountryFlagDisplay.vue?vue&type=script&lang=js"
export * from "./CountryFlagDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303f7632",
  null
  
)

export default component.exports